$(function () {
  if($('.welcome-page-container').length === 0) return;

  let pricingTier = {};
  $('#meal-calculator-modal .input-name-location').keyup(handleChange).change(handleChange).blur(handleChange);
  $('input[name="pail-quantity"], input[name="bowl-quantity"]').on('keyup blur change',function () {
    $(this).val(parseInt($(this).val()));
    updatePrice();
  });

  function updatePrice() {
    let data = $('#meal-calculator-modal form').serializeObject();
    let total = (parseFloat(data['pail-quantity']) || 0) * (pricingTier.pail || 0)
        + (parseFloat(data['bowl-quantity']) || 0) * (pricingTier.bowl || 0);
    $('#meal-calculator-modal [data-prop="total-price"]').text('$' + total.toFixed(2));
  }
  
  function  handleChange(e) {
    if(e.currentTarget.value === "") {
      resetCalculator();
    }
  }

  function  resetCalculator() {
      $('#meal-calculator-modal form [data-prop="price-pail"]').text('($0.00 EA)');
      $('#meal-calculator-modal form [data-prop="price-bowl"]').text('($0.00 EA)');
      $('#meal-calculator-modal form [name="pail-quantity"]').val('');
      $('#meal-calculator-modal form [name="bowl-quantity"]').val('');
      $('#meal-calculator-modal [data-prop="total-price"]').text('$0.00');
      $('#meal-calculator-modal form .form-group.quantity-fields').addClass('disabled');
      $('#meal-calculator-modal .modal-footer .pricing-note').text("");
  }

  createSuggestor({
    suggester: $('#location-suggestions'),
    input: $('.input-name-location'),
    url: '/anonymous/school-lunch/stores?searchText={str}',
    buildItem: function (store) {
      let storeInfo = generateStoreNameForGuest(store);

      return $('<div>').attr(
          {
            'data-number': store.number,
            'data-city': store.city,
            'data-state': store.state,
            'data-address': store.address1,
          }).html(storeInfo);
    },
    onSelect: function (selection, input) {
      resetCalculator();
      selection = selection.data();

      input.val('#' + selection.number + ' - ' + ' ' + selection.city + ', ' + selection.state).data({
        value: selection.number
      }).trigger('change');

      $('#meal-calculator-modal .modal-footer .pricing-note').text('Pricing at #' + selection.number + ', ' + selection.address + ' on ' + (new Date().format('F d, Y')));

      request({
        url: '/anonymous/school-lunch/prices-by-store?storeNumber=' + selection.number,
        data: {},
        callback: function (p) {
          pricingTier = p;

          if(pricingTier.pail) {
            $('#meal-calculator-modal form [data-prop="price-pail"]').text('($' + pricingTier.pail + ' EA)');
            $('#meal-calculator-modal form [data-prop="price-bowl"]').text('($' + pricingTier.bowl + ' EA)');
            $('#meal-calculator-modal form .form-group.quantity-fields').removeClass('disabled');
          }
        }
      });
      
      updatePrice()
    }
  });

  $('.open-calculator-btn').click(function () {
    $('#meal-calculator-modal').modal('show');
  });
  $('.prm-step-link').click(function (){
    $('#prm-info-modal').modal('show');
  });

  if(getParam('cost_calculator') === 'visible'){
    $('#meal-calculator-modal').modal('show');
  }

  $('.accordion .item .header').click(function () {
    let item = $(this).closest('.item');
    if(item.hasClass('expanded')) {
      item.removeClass('expanded');
    } else {
      $('.accordion .item').removeClass('expanded');
      item.addClass('expanded');
    }
  });

  let postersCarousel = $('.posters.owl-carousel').owlCarousel({
    loop: false,
    nav: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    freeDrag: false,
    items: 1
  });

  let captionsCarousel = $('.captions.owl-carousel').owlCarousel({
    loop: false,
    nav: false,
    dots: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    freeDrag: false,
    items: 1,
  });

  postersCarousel.on('changed.owl.carousel', function(event) {
    captionsCarousel.trigger('to.owl.carousel', [event.page.index]);
  });

  captionsCarousel.on('changed.owl.carousel', function(event) {
    postersCarousel.trigger('to.owl.carousel', [event.page.index]);
  });

  $('.programs.owl-carousel').owlCarousel({
    items: 3,
    padding: 50,
    navText : ["<img src='/img/school-lunch/angle-left.png' alt='Angle left'>","<img src='/img/school-lunch/angle-right.png' alt='Angle right'>"],
    responsive: {
      0 : {
        items: 1,
      },
      768: {
        items: 2,
      },
      1000: {
        items: 3,
      }
    },
    dots: false,
    onInitialized: function(event) {
      $('.programs.owl-carousel .owl-prev, .programs.owl-carousel .owl-next').removeAttr('role')
      $('.programs.owl-carousel .owl-prev').attr('aria-label', 'Previous slide');
      $('.programs.owl-carousel .owl-next').attr('aria-label', 'Next slide');
    }
  });

  let lnyActivitiesCarousel = $('#carouselExampleSlidesOnly .owl-carousel').owlCarousel({
    loop: true,
    nav: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    freeDrag: false,
    singleItem:true,
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
  }).on('changed.owl.carousel', function(event) {
    lnyActivitiesCarousel.trigger('to.owl.carousel', [event.page.index]);
  });


  $(document).on("focusin click", e => {
    if($(window).width() > 768) return;
    const $inMenu = $(e.target).closest(".main-menu, .main-menu-mobile-nav");
    if ($inMenu.length !== 0) return;
    if ($('.mob-menu-overlay.visible').length) $(".mobile-only.close-menu-btn").trigger("click");
  })

  function generateStoreNameForGuest(store, onlyAddress) {
    let storeName = store.name || "";
    let storeAddres1 = store.address1 || "";
    let storeCity = "";
    let storeState = "";
    let storeZip = "";
    if (store.city) {
      storeCity = ', ' + store.city;
    }
    if (store.state) {
      storeState = ', ' + store.state;
    }
    if (store.zipCode) {
      storeZip = ', ' + store.zipCode;
    }
    if (onlyAddress) {
      return storeAddres1 + storeCity + storeState + storeZip;
    }
    return '#' + store.number + ' - ' + storeName + '<br><small>' + storeAddres1 + storeCity + storeState + storeZip + '</small>';
  }

  Date.prototype.format = function (format, utc) {
    if (isNaN(this.valueOf())) {
      return 'Invalid Date';
    }

    let fullMonthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];

    let shortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    let fullDayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday",
      "Friday", "Saturday"];

    let shortDayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    let fullYear = utc ? this.getUTCFullYear() : this.getFullYear();
    let humanYear = fullYear - 2000;

    let month = utc ? this.getUTCMonth() : this.getMonth();
    let monthHumanRaw = month + 1;
    let monthHuman = monthHumanRaw > 9 ? monthHumanRaw : '0' + monthHumanRaw;

    let date = utc ? this.getUTCDate() : this.getDate();
    let humanDate = date > 9 ? date : '0' + date;

    let hour = utc ? this.getUTCHours() : this.getHours();
    let human24Hour = hour > 9 ? hour : '0' + hour;

    let human12Hour = hour % 12;
    if (hour === 12) {
      human12Hour = 12;
    }
    human12Hour = human12Hour > 9 ? human12Hour : '0' + human12Hour;

    let ampm = hour > 11 ? 'pm' : 'am';

    let minute = utc ? this.getUTCMinutes() : this.getMinutes();
    let humanMinute = minute > 9 ? minute : '0' + minute;

    let second = utc ? this.getUTCSeconds() : this.getSeconds();
    let humanSecond = second > 9 ? second : '0' + second;

    let day = utc ? this.getUTCDay() : this.getDay();

    let result = format
      .replace(/d/, '__d__')
      .replace(/j/, '__j__')
      .replace(/m/, '__m__')
      .replace(/n/, '__n__')
      .replace(/Y/, '__Y__')
      .replace(/y/, '__y__')
      .replace(/H/, '__H__')
      .replace(/h/, '__h__')
      .replace(/a/, '__a__')
      .replace(/A/, '__A__')
      .replace(/i/, '__i__')
      .replace(/s/, '__s__')
      .replace(/F/, '__F__')
      .replace(/M/, '__M__')
      .replace(/l/, '__l__')
      .replace(/D/, '__D__');

    return result
      .replace(/__d__/, humanDate)
      .replace(/__j__/, date)
      .replace(/__m__/, monthHuman)
      .replace(/__n__/, monthHumanRaw)
      .replace(/__Y__/, fullYear)
      .replace(/__y__/, humanYear)
      .replace(/__H__/, human24Hour)
      .replace(/__h__/, human12Hour)
      .replace(/__a__/, ampm)
      .replace(/__A__/, ampm.toUpperCase())
      .replace(/__i__/, humanMinute)
      .replace(/__s__/, humanSecond)
      .replace(/__F__/, fullMonthNames[month])
      .replace(/__M__/, shortMonthNames[month])
      .replace(/__l__/, fullDayNames[day])
      .replace(/__D__/, shortDayNames[day]);
  };
});